import { turbine1dQuery, turbineStateQuery, catchErrorsV2 } from '../ReportsAPI';
import {
    collectTurbineData,
    collectTurbineStateData,
    sortTurbineStatuses,
    filterTurbineData,
    isTurbine,
} from 'routes/Reports/models/helpers/performance.helper';
import { getSelectedItems, getSelectedParkData } from 'common/state.helper';
import { map } from 'lodash';
import { isRealTurbine } from 'common/sites.util';

const defaultTurbineState = {
    allTurbineSummaries: null,
    allTurbineStatuses: null,
    turbineSummaries: null,
    turbineStatuses: null,
    filter: [],
    sort: { ascending: false, sortKey: 'average' },
};

const performance = {
    name: 'performance',
    state: defaultTurbineState,
    reducers: {
        setSort(state, { ascending, sortKey, turbineStatuses }) {
            return { ...state, sort: { ascending, sortKey }, turbineStatuses };
        },
        setFilter(state, { filter, turbineStatuses, turbineSummaries, allTurbineStatuses, allTurbineSummaries }) {
            return {
                ...state,
                filter,
                turbineStatuses,
                turbineSummaries,
                allTurbineStatuses,
                allTurbineSummaries,
            };
        },
        setChartData(state, { turbineSummaries, turbineStatuses }) {
            return {
                ...state,
                turbineSummaries,
                turbineStatuses,
            };
        },
        resetTurbineData() {
            return defaultTurbineState;
        },
    },
    effects: (dispatch) => ({
        async loadAll() {
            await catchErrorsV2(
                () => dispatch.performance.queryData(),
                () => dispatch.performance.resetTurbineData()
            );
        },
        async queryData(_, state) {
            const { selectedDate, selectedParkId } = await getSelectedItems(state);
            const turbineResp = await turbine1dQuery(selectedDate, selectedParkId);
            const turbineStateResp = await turbineStateQuery(selectedDate, selectedParkId);
            const parkData = await getSelectedParkData();
            const turbineIds = map(parkData.turbines.filter(isRealTurbine), 'id');
            const turbineSummaries = collectTurbineData(turbineResp.data).filter(isTurbine(turbineIds));
            const turbineStatuses = collectTurbineStateData(turbineStateResp.data, turbineSummaries, selectedDate);

            dispatch.performance.setChartData({ turbineSummaries, turbineStatuses });
            dispatch.performance.setFilter({
                filter: [],
                turbineStatuses,
                turbineSummaries,
                allTurbineSummaries: turbineSummaries,
                allTurbineStatuses: turbineStatuses,
            });
            dispatch.performance.sortStatuses({ ascending: false, sortKey: 'average' });
        },
        async sortStatuses({ sortKey }, state) {
            const store = state.performance;
            const statuses = [...store.turbineStatuses];
            const { ascending } = store.sort;

            const newDirection = store.sort.sortKey === sortKey ? !ascending : ascending;

            sortTurbineStatuses(statuses, sortKey, newDirection);

            dispatch.performance.setSort({
                ascending: newDirection,
                sortKey,
                turbineStatuses: statuses,
            });
        },
        async filterStatuses({ filterKey }, state) {
            const store = state.performance;
            let { allTurbineStatuses, allTurbineSummaries } = store;

            if (!allTurbineStatuses.length || !allTurbineSummaries.length) {
                allTurbineStatuses = store.turbineStatuses;
                allTurbineSummaries = store.turbineSummaries;
            }

            const { filter, filteredStatuses, filteredSummaries } = filterTurbineData(
                store.filter,
                filterKey,
                allTurbineStatuses,
                allTurbineSummaries
            );

            dispatch.performance.setFilter({
                filter,
                turbineStatuses: filteredStatuses,
                turbineSummaries: filteredSummaries,
                allTurbineStatuses,
                allTurbineSummaries,
            });
        },
    }),
};

export default performance;
